import { AgencyProfileOption, SubdivisionOptionsBootstrapView } from '@mark43/cad-api';
import {
    EventClassPrefix,
    GenericObject,
    SubdivisionFieldName,
    SubdivisionFieldParam,
    SubdivisionFieldSuffix,
} from '../types';
import { capitalize } from 'lodash';

type SubdivisionOptionsPath = `${SubdivisionFieldName}Options`;
type SubdivisionLabelPath = `${SubdivisionFieldName}Label`;

const subdivisionFieldSuffixes: SubdivisionFieldSuffix[] = [
    'Subdivision5',
    'Subdivision4',
    'Subdivision3',
    'Subdivision2',
    'Subdivision1',
];

function addSpaceBeforeLastCharacter(suffix: SubdivisionFieldSuffix) {
    return suffix.slice(0, -1) + ' ' + suffix.slice(-1);
}

const getSubdivisionFieldDefaultLabel = (
    eventClassPrefix: EventClassPrefix,
    suffix: SubdivisionFieldSuffix
) => `${capitalize(eventClassPrefix)} ${addSpaceBeforeLastCharacter(suffix)}`;

export function getEventSubdivisionFieldsParams({
    eventClassPrefix,
    agencyValue,
    multiAgencySubdivisions,
    allSubdivisionOptions,
    agencySubdivisionOptions,
}: {
    eventClassPrefix: EventClassPrefix;
    agencyValue: AgencyProfileOption | null;
    multiAgencySubdivisions: boolean;
    allSubdivisionOptions?: SubdivisionOptionsBootstrapView;
    agencySubdivisionOptions?: GenericObject<SubdivisionOptionsBootstrapView>;
}): SubdivisionFieldParam[] | undefined {
    if (!allSubdivisionOptions || !agencySubdivisionOptions) {
        return;
    }

    return subdivisionFieldSuffixes
        .map((suffix) => {
            const fieldName: SubdivisionFieldName = `${eventClassPrefix}${suffix}`;
            const fieldOptionsPath: SubdivisionOptionsPath = `${fieldName}Options`;
            const fieldLabelPath: SubdivisionLabelPath = `${fieldName}Label`;
            const agencyId = agencyValue?.value;
            const fieldOptions =
                multiAgencySubdivisions && agencyId && agencySubdivisionOptions[agencyId]
                    ? agencySubdivisionOptions[agencyId][fieldOptionsPath]
                    : allSubdivisionOptions[fieldOptionsPath];
            const fieldLabel =
                multiAgencySubdivisions && agencyId && agencySubdivisionOptions[agencyId]
                    ? agencySubdivisionOptions[agencyId][fieldLabelPath]
                    : allSubdivisionOptions[fieldLabelPath];

            const label = fieldLabel ?? getSubdivisionFieldDefaultLabel(eventClassPrefix, suffix);

            return {
                name: fieldName,
                options: fieldOptions,
                label,
            };
        })
}
